import { __assign, __awaiter, __generator } from "tslib";
import { parse } from 'cookie';
import { axios } from '../utils/axios';
import { isValidURL, getUach } from './utils';
import { stringify } from '../utils/polyfills';
var PC = 'PC';
var SP = 'SP';
function isRATAvailable() {
    return (typeof window !== 'undefined' &&
        !!window.RAT &&
        typeof window.RAT.addCustomEvent === 'function');
}
function getRatData(_a) {
    var _b = _a.screen, screen = _b === void 0 ? 'EMPTY' : _b, _c = _a.action, action = _c === void 0 ? 'EMPTY' : _c, _d = _a.version, version = _d === void 0 ? '' : _d, campaignId = _a.campaignId, contentId = _a.contentId, clientId = _a.clientId, _e = _a.ratAccountId, ratAccountId = _e === void 0 ? '' : _e, _f = _a.ratServiceType, ratServiceType = _f === void 0 ? '' : _f, _g = _a.ratServiceId, ratServiceId = _g === void 0 ? '' : _g, _h = _a.message, message = _h === void 0 ? null : _h, _j = _a.pgl, pgl = _j === void 0 ? PC : _j, _k = _a.userId, userId = _k === void 0 ? '' : _k, _l = _a.sessionId, sessionId = _l === void 0 ? '' : _l, correlationId = _a.correlationId, replacementId = _a.replacementId, selector = _a.selector, impressionId = _a.impressionId;
    var serviceId = ratServiceId === '' ? '1' : ratServiceId;
    return {
        accountId: +ratAccountId,
        serviceId: +serviceId,
        pData: {
            compid: [screen, action],
            app_ver: version,
            pgl: pgl,
        },
        cpData: __assign(__assign(__assign(__assign(__assign(__assign({ service_acc: +ratAccountId, service_id: +serviceId, service_type: ratServiceType, message: stringify(message), user_id: userId, session_id: sessionId, client_id: clientId }, (replacementId ? { replacement_id: replacementId } : {})), (campaignId ? { campaign_id: campaignId } : {})), (contentId ? { content_id: contentId } : {})), (correlationId !== undefined ? { issue_id: correlationId } : {})), (selector ? { selector_id: selector } : {})), (impressionId ? { impression_id: impressionId } : {})),
        options: ['url', 'ua'],
        eventType: 'async',
    };
}
function postEventToRAT(data, apiURL) {
    if (apiURL === void 0) { apiURL = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, Ra, Rp, Rz, uachData, accountId, serviceId, pData, cpData, eventType, ratData, dataString, jsonResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = parse(document.cookie), Ra = _a.Ra, Rp = _a.Rp, Rz = _a.Rz;
                    return [4 /*yield*/, getUach()];
                case 1:
                    uachData = _b.sent();
                    accountId = data.accountId, serviceId = data.serviceId, pData = data.pData, cpData = data.cpData, eventType = data.eventType;
                    ratData = __assign({ acc: accountId, aid: serviceId, etype: eventType, compid: pData.compid, app_ver: pData.app_ver, pgl: pData.pgl, cp: cpData, url: window.location.href, ua: navigator.userAgent, _ra: Ra, cks: Rp, cks2: Rp, ckp: Rz, use_cks: true, pgn: window.location.pathname }, uachData);
                    dataString = "cpkg_none=".concat(stringify(ratData));
                    return [4 /*yield*/, axios.post(apiURL, dataString, {
                            headers: { 'Content-Type': 'text/plain' },
                        })];
                case 2:
                    jsonResponse = _b.sent();
                    return [2 /*return*/, jsonResponse.data];
            }
        });
    });
}
export function Track(_a) {
    var _b;
    var _c = _a.screen, screen = _c === void 0 ? 'EMPTY' : _c, _d = _a.action, action = _d === void 0 ? 'EMPTY' : _d, _e = _a.version, version = _e === void 0 ? '' : _e, _f = _a.projectKey, projectKey = _f === void 0 ? '' : _f, _g = _a.ratAccountId, ratAccountId = _g === void 0 ? '' : _g, _h = _a.ratServiceType, ratServiceType = _h === void 0 ? '' : _h, _j = _a.ratServiceId, ratServiceId = _j === void 0 ? '' : _j, _k = _a.userId, userId = _k === void 0 ? '' : _k, _l = _a.sessionId, sessionId = _l === void 0 ? '' : _l, _m = _a.clientId, clientId = _m === void 0 ? '' : _m, _o = _a.isMobile, isMobile = _o === void 0 ? false : _o, campaignId = _a.campaignId, contentId = _a.contentId, _p = _a.message, message = _p === void 0 ? null : _p, correlationId = _a.correlationId, selector = _a.selector, replacementId = _a.replacementId, impressionId = _a.impressionId, ratApiAccountSrc = _a.ratApiAccountSrc, _q = _a.isRatCoreEventsOnly, isRatCoreEventsOnly = _q === void 0 ? false : _q, _r = _a.isPreview, isPreview = _r === void 0 ? false : _r;
    return __awaiter(this, void 0, void 0, function () {
        var screenProductPrefix_1, type, coreEventsList, ratData, e_1;
        return __generator(this, function (_s) {
            switch (_s.label) {
                case 0:
                    _s.trys.push([0, 4, , 5]);
                    screenProductPrefix_1 = [projectKey, screen].join('_');
                    type = isMobile ? SP : PC;
                    coreEventsList = [
                        { screen: 'RMCCX_BLOCKS_METRIC', action: 'VIEW' },
                        { screen: 'RMCCX_BLOCKS_METRIC', action: 'CLICK' },
                        { screen: 'RMCCX_BLOCKS_METRIC', action: 'HIT' },
                        { screen: 'RMCCX_BLOCKS_MESSAGE_API', action: 'ERROR' },
                        { screen: 'RMCCX_BLOCKS_MESSAGE_API', action: 'NO_RESPONSE' },
                        { screen: 'RMCCX_BLOCKS_MESSAGE_API', action: 'NOT_VALID' },
                    ];
                    if (isRatCoreEventsOnly &&
                        !coreEventsList.some(function (event) {
                            return event.screen === screenProductPrefix_1 && event.action === action;
                        })) {
                        return [2 /*return*/, null];
                    }
                    if (isPreview) {
                        return [2 /*return*/, null];
                    }
                    ratData = getRatData({
                        screen: screenProductPrefix_1,
                        action: action,
                        version: version,
                        campaignId: campaignId,
                        contentId: contentId,
                        ratAccountId: ratAccountId,
                        ratServiceType: ratServiceType,
                        ratServiceId: ratServiceId,
                        message: message,
                        pgl: type,
                        userId: userId,
                        sessionId: sessionId,
                        clientId: clientId,
                        correlationId: correlationId,
                        selector: selector,
                        replacementId: replacementId,
                        impressionId: impressionId,
                    });
                    if (!isValidURL(ratApiAccountSrc)) return [3 /*break*/, 2];
                    return [4 /*yield*/, postEventToRAT(ratData, ratApiAccountSrc)];
                case 1:
                    _s.sent();
                    return [3 /*break*/, 3];
                case 2:
                    if (isRATAvailable()) {
                        (_b = window.RAT) === null || _b === void 0 ? void 0 : _b.addCustomEvent(ratData);
                    }
                    else {
                        // eslint-disable-next-line no-console
                        console.log("[RAT-SIMULATOR] ".concat(stringify(ratData.pData.compid)), ratData);
                    }
                    _s.label = 3;
                case 3: return [2 /*return*/, ratData];
                case 4:
                    e_1 = _s.sent();
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
